import React, { useContext } from 'react';
import { FormStatus } from './FormStatus';
import { SearchInput } from '../SearchInput';
import { MoreOptionsModal } from './MoreOptionsModal';
import { useFormsContext } from '../context/FormsProvider';
import { useStyles } from './styles';
import { Button } from '@material-ui/core';
import { IRouterProps } from 'pages/orderHistory';
import { AuthContext } from 'contexts/AuthContext';
import { ClearFilterButton } from 'components/Buttons/ClearFilterButton';

export const Filters = ({ router }: IRouterProps) => {
  const { search, handleSearch, defineFilters, handleClearSearch } = useFormsContext();
  const {
    user: { isVisaoTok }
  } = useContext(AuthContext);
  const styles = useStyles();

  const handleRedirect = () => {
    router.push('formularios/cadastrar');
  };

  const handleStartSearch = () => defineFilters();

  return (
    <>
      <div className={styles.inputContainer}>
        <SearchInput
          handleChange={handleSearch}
          applyFilter={handleStartSearch}
          isFilterApplied={!!search}
          label="ID / Nome do Formulário"
          text={search}
        />
        <ClearFilterButton onClick={handleClearSearch} />
        {isVisaoTok && (
          <Button variant="contained" color="secondary" onClick={handleRedirect}>
            Cadastrar Formulário
          </Button>
        )}
      </div>
      <div style={{ width: '300px' }}>
        <MoreOptionsModal />
        <FormStatus />
      </div>
    </>
  );
};
